<template>
  <div class="queryOrder">
    <!-- <div class="nav_bar">
      <van-nav-bar title="停车缴费" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>
    </div> -->
    <div class="adsense_space" @click="gotoAdsencePage(adsence)">
         <img :src="adsence.picUrl" >
    </div>
    <div class="car_num_holder"></div>
    <carNum-input @getcarNum="getcarNum"></carNum-input>
    <van-button class="bt_qurey" color="#f47b20" @click="queryBycarNum">查询缴费</van-button>
    
  </div>
</template>

<script>
import { mySessionStorage } from '@/utils/storage.js'
export default {
  name: "queryOrder",
  data() {
    return {
      title: "",
      active: "2",
      carNum: "",
      openid:"",
      adsence:{

      },
      orderDetails:{
        shouldPay:"",
        needPay:"",
        parkingTime:"",
        startTime:"",
        parkName:"",
        orderId:"",
        type:"",
        carNum:"",
        companyId:""
      },
      adsenceImgUrl:"../static/img/adsence4.jpg",
      
    };
  },
  methods: {
    onClickLeft() {
      console.log("返回");
      this.$router.push("/menu");
    },

    getcarNum(carNum){
      console.log(carNum);
      this.carNum=carNum;
    },
    //获取广告列表
    getAdsense(){
      let params = {
        site:0
      };
      console.log(this.carNum);
      this.$http
        .post(this.$api.queryAdvert, params)
        .then(res => {
          if (res.code == 200) {
           this.adsence=res.data[0];
           //初始化广告数据存缓存
             if(mySessionStorage.getItem(res.data.id)==null){
                console.log("刷新执行测试")
                let startDate=new Date().getTime();
                mySessionStorage.setItem(res.data[0].id,{"startDate":startDate,"showCount":1,"clickCount":0});
             }
          }
          else{
  
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
        //离开页面计算广告数据
    calcAdvertdata() {
      //判断是是否是刷新
      let that = this;
        let AdObj = mySessionStorage.getItem(this.adsence.id);
        //清空缓存
        window.sessionStorage.removeItem(this.adsence.id);
        let startDate = AdObj.startDate;
        let stay = ((new Date().getTime() - startDate) / 1000).toFixed(0);
        if (stay >= 5) {//停留大于5秒向后退更新
          console.log("停留时间", new Date().getTime());
          console.log("停留时间", stay);
          let params = {
            id: this.adsence.id,
            showCount: AdObj.showCount,
            clickCount: AdObj.clickCount,
            stay: stay
          }
          console.log(params);
          this.$http
            .post(this.$api.advertUpdate, params)
            .then(res => {

            })
            .catch(err => {
              console.log(err);
            });
        }
    },
    updateAdvertSession(id){
      let AdObj=mySessionStorage.getItem(id);
      console.log(AdObj);
      AdObj.clickCount+=1;
      mySessionStorage.setItem(id,AdObj);
    },
    //跳转到广告页面
    gotoAdsencePage(adsence){
      this.updateAdvertSession(adsence.id);
      
      window.location.href=adsence.clickUrl;
    },
    queryBycarNum() {
      let params = {
        carNum: this.carNum
      };
      console.log(this.carNum);
      this.$http
        .post(this.$api.queryWechatOrder, params)
        .then(data => {
          if (data.code == 200) {
            var resData=data.data[0];
            this.orderDetails.shouldPay=resData.shouldPay;
            this.orderDetails.needPay=resData.needPay;
            this.orderDetails.parkingTime=resData.parkingTime;
            this.orderDetails.startTime=resData.order.startTime;
            this.orderDetails.parkName=resData.order.parkName;
            this.orderDetails.orderId=resData.order.id;
            this.orderDetails.type=resData.type;
            this.orderDetails.companyId=resData.order.companyId;
            this.orderDetails.carNum=this.carNum;
            this.goToOrderInfo(this.orderDetails);

          }
          else{
            this.$toast.fail("暂无在停订单");
          }
        })
        .catch(err => {
          console.log(err);
           this.$toast.fail("暂无在停订单");
        });
    },
    //跳转到订单详情页
    goToOrderInfo(orderInfo){
      this.$router.push(
        {
          name:"orderDetails",
          query:{
            shouldPay:this.orderDetails.shouldPay,
            needPay:this.orderDetails.needPay,
            parkingTime:this.orderDetails.parkingTime,
            startTime:this.orderDetails.startTime,
            parkName:this.orderDetails.parkName,
            orderId:this.orderDetails.orderId,
            type:this.orderDetails.type,
            companyId:this.orderDetails.companyId,
            carNum:this.orderDetails.carNum,
            payLevel:0
          }
        }
      );
    },
    //根据openid查询是否有绑定车牌
    getBindCar(){
      let params = {
        openid: this.openid,
      };
      this.$http
        .post(this.$api.queryBindCar, params)
        .then(res => {
          console.log("车牌信息:", res);
          console.log("车牌信息:", res.data.length);
          if (res.data.length>0) {
            //跳转到carNumOrder页面
            this.goToCarNumOrder(res.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //跳转到carNumOrder页面
    goToCarNumOrder(carNumList){
      this.$router.push(
        {
          name:"carNumOrder",
          params:{
            carNumList:carNumList
          }
        }
      );
    }

    
  },
  created() {
    this.openid=mySessionStorage.getItem("openid");
  },
  mounted(){
    this.getAdsense();
    window.addEventListener('beforeunload', e => {
      this.calcAdvertdata();
    });
  },
  beforeDestroy(){
    this.calcAdvertdata();
  }
};
</script>

<style scoped>
.queryOrder {
  min-height: 100%;
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: #e8e9eb;
  float: left;
}
.adsense_space{
  width: 100%;
  height: 25%;
}
.adsense_space img{
    height: 100%;
    width: 100%;
}
.nav_bar {
  width: 100%;
  height: 46px;
  float: left;
}
.car_num_holder {
  height: 40px;
  width: 100%;
  float: left;
}
.bt_qurey {
  width: 80%;
  margin-left: 10%;
  margin-top: 30px;
  border-radius: 5px;
  height: 36px;
  /* position: fixed;
  display: block; */
}
</style>



// WEBPACK FOOTER //
// src/components/order/queryOrder.vue